import { PreguntaExportador } from "../PreguntaExportador";
import { PreguntasTipoEnum } from "@shared/enums";

export class PreguntaFlowCheckpointExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.FLOW_CHECKPOINT;
    }
}
